import { Check } from "lucide-react";
import { BENEFITS } from "../data/mock";

export const Benefits = () => {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="relative py-20 md:py-28 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="text-xs tracking-[0.22em] uppercase font-semibold text-orange-500">
            Why Reptile Hisabbook
          </span>
          <h2
            data-testid="benefits-headline"
            className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
          >
            Built for the way{" "}
            <span className="text-teal-600">India does business</span>.
          </h2>
        </div>

        <div className="space-y-16 md:space-y-24">
          {BENEFITS.map((b, idx) => {
            const reversed = idx % 2 === 1;
            return (
              <div
                key={b.title}
                data-testid={`benefit-block-${idx}`}
                className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                  reversed ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div>
                  <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1 shadow-sm">
                    <span className="h-2 w-2 rounded-full bg-emerald-500" />
                    <span className="text-xs uppercase tracking-[0.18em] font-semibold text-slate-700">
                      Benefit {String(idx + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-heading mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 leading-tight">
                    {b.title}
                  </h3>
                  <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
                    {b.desc}
                  </p>
                  <ul className="mt-6 space-y-3">
                    {b.bullets.map((bullet, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <span className="mt-1 h-6 w-6 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center shrink-0">
                          <Check className="h-3.5 w-3.5" strokeWidth={3} />
                        </span>
                        <span className="text-slate-700">{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="relative">
                  <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-tr from-teal-200/40 to-orange-200/40 blur-2xl -z-10" />
                  <div className="rounded-[2rem] overflow-hidden bg-white border border-slate-200 shadow-xl shadow-slate-300/30 aspect-[5/4]">
                    <img
                      src={b.image}
                      alt={b.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      data-testid={`benefit-image-${idx}`}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
